import { Component, OnInit, Input} from '@angular/core';

@Component({
  selector: 'lean-step',
  templateUrl: './lean-step.component.html',
  styleUrls: ['./lean-step.component.scss']
})
export class LeanStepComponent implements OnInit {

  @Input() stepIndex      : number;
  @Input() currentIndex   : number;
  @Input() title          : string;
  @Input() passed         : boolean;
  @Input() first          : boolean;
  @Input() last           : boolean;
  

    constructor() { }

  ngOnInit() {
  }


  getIcon() : string {
    if (this.passed)                          return "assets/images/icons/circle-blue.png";
    if (this.currentIndex == this.stepIndex)  return "assets/images/icons/circle-blue-empty.png";
                                              return  "assets/images/icons/circle-white.png";
  }

  getBar1() : string{
    if (this.first)                          return "nothing";
    if (this.passed)                         return "passed";
    if (this.currentIndex == this.stepIndex) return "passed";
    return  "notyet";
  }


  getBar2() : string{
    if (this.last)                           return "nothing";
    if (this.passed)                         return "passed";
    if (this.currentIndex == this.stepIndex) return "notyet";
    return  "notyet";
  }

  getTextColorClass() : string{
    if (this.passed)  return "passed-text";
    return "neutral-text";
  }

  getStepIndex() : number{
    return this.stepIndex + 1;
  }


}
